// Message bref (toast) : une ligne en bas de l'écran, qui disparaît seule. N'interrompt jamais le jeu.
import { $ } from './dom.js';

export const TOAST_MS = 2800;

export function createToast(el = $('toast')) {
  let timer = null;
  return {
    show(text, ms = TOAST_MS) {
      clearTimeout(timer);
      el.textContent = text;
      el.classList.add('is-visible');
      timer = setTimeout(() => el.classList.remove('is-visible'), ms);
    },
    hide() {
      clearTimeout(timer);
      el.classList.remove('is-visible');
    },
  };
}
